import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 7 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m4.376 5.652-4.1-4.1a.875.875 0 0 1 0-1.276.875.875 0 0 1 1.284.008L6.3 5.027c.162.17.252.395.25.63q0 .179-.061.338a.8.8 0 0 1-.188.282l-4.742 4.741q-.283.285-.633.27a.9.9 0 0 1-.625-.287.875.875 0 0 1 0-1.274z"
    }, null, -1)
  ]))]))
}
export default { render: render }